import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { userActions } from 'day8-react';
import { Input, FormWrap, Button, toast } from 'day8-ui';
import history from '../../history';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // Prefilled when we sent the guest here from a blocked login, so they do
      // not have to retype the address they just entered.
      email: props.initialEmail
        || (props.location && props.location.state && props.location.state.forcedResetEmail)
        || '',
      loading: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(e) {
    e.preventDefault();

    this.setState({ loading: true });
    const { email } = this.state;
    const result = await this.props.requestPassword(email);
    if (result.status === 'success') {
      toast.success("Password reset link sent — check your spam folder if you do not see it");
      // Replace `description` rather than spreading it forward: when a blocked
      // login sent the guest here it holds the "you must reset your password"
      // message, and carrying it into the reopened login modal makes a successful
      // request look like another failed login. `forcedResetEmail` is dropped for
      // the same reason — the redirect has served its purpose.
      const previousState = history.location.state || {};
      const keptState = Object.keys(previousState).reduce((acc, key) => {
        if (key !== 'description' && key !== 'forcedResetEmail') {
          acc[key] = previousState[key];
        }
        return acc;
      }, {});
      history.replace({
        pathname: history.location.pathname,
        search: history.location.search,
        state: {
          ...keptState,
          showLoginModal: true,
          page: 'login',
          description: `We have emailed a password reset link to ${email}. Follow it to set a new password, then log in. If it does not arrive within a few minutes, check your spam or junk folder.`
        }
      });
      return;
    }
    toast.error("Something went wrong. Please try again");
    this.setState({ loading: false });
  }

  render() {
    const {
      loading, email
    } = this.state;
    const { loginTo } = this.props;
    return (
      <div>
        <FormWrap onSubmit={this.handleSubmit}>
          <div className='dui-flex dui-flex-col dui-gap-4'>
            <Input
              id="login_email"
              type="email"
              label="Email"
              className='dui-w-full'
              labelHidden
              placeholder="Your email"
              value={email}
              onChange={e => this.setState({ email: e.target.value })}
            />
            <Button
              disabled={loading}
              type="submit"
            >{loading ? "Submitting..." : "Submit"}</Button>
          </div>
        </FormWrap>
        <p className="dui-mt-4 dui-text-sm dui-text-gray-400">
          Already have an account?{' '}
          <Link to={loginTo || 'login'} className="dui-underline">
            Log in
          </Link>
        </p>
      </div>
    );
  }
}

Login.propTypes = {
  requestPassword: PropTypes.func.isRequired,
  loginTo: PropTypes.object,
  initialEmail: PropTypes.string,
  location: PropTypes.object
};

const mapStateToProps = store => ({
  user: store.user.loggedUser
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      requestPassword: userActions.requestPassword
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Login);
